export default __webpack_public_path__ + "static/media/cesty-pathways.35b59433.png";